// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._16qskkzs{box-shadow:var(--_es7za0)}\n._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._bfhk13b4{background-color:var(--_1f6rtr1)}\n._ca0qv77o{padding-top:var(--ds-space-025,2px)}\n._n3tdv77o{padding-bottom:var(--ds-space-025,2px)}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
